import { FormConfigurationProvider, ModelCheckbox } from '@equifinance/shared';
import { formatDateTime } from '@equifinance/shared/utils';
import styled from 'styled-components';
import {
  Divider, InfoPanel, SubmitContainer, SubmittedText,
} from '../../components/UnderwriterDecision';
import {
  useChecklistContext,
} from '../../../../contexts';
import { ChecklistSection } from '../../ChecklistPage';
import { PaddedGenericSection } from '../GenericSection';
import AvmSearchSection from './Sections/AvmSearchSection';
import AvmResultsSection from './Sections/AvmResultsSection';
import ValuationResultsSection from './Sections/ValuationResultsSection';
import ValuationUnderwriterDecision from './Sections/UnderwriterDecision';
import { usePageConfigurationContext } from '../../../../contexts/pageConfiguration';
import ValuationDocumentsSection from './Sections/Documents';

export const ValuationRefName = 'valuation';

const ButtonContainer = styled.div`
  width: fit-content;
`;

export default function ValuationSection() {
  const { checklist } = useChecklistContext();
  const { valuation, errors, warnings } = checklist ?? {};
  const {
    checklistIndicatorType, submitted, submittedByName, submittedTimestamp, canSubmit,
  } = valuation ?? {};

  const { isReadOnly: isPageReadOnly } = usePageConfigurationContext();
  const isSectionDisabled = submitted || checklistIndicatorType === 'Locked';

  return (
    <PaddedGenericSection
      refName={ValuationRefName}
      section={ChecklistSection.VALUATION}
      subSection={ChecklistSection.NOTES_VALUATION}
      checklistItem={valuation}
      errors={errors}
      warnings={warnings}
    >
      <FormConfigurationProvider isReadOnlyInput={isPageReadOnly || isSectionDisabled}>
        <AvmSearchSection />
        <AvmResultsSection />
        <ValuationResultsSection />
        <ValuationDocumentsSection />
        <ValuationUnderwriterDecision />
      </FormConfigurationProvider>

      <SubmitContainer>
        {submitted && submittedByName && submittedTimestamp && (
          <InfoPanel>
            <SubmittedText>
              {submittedByName}
            </SubmittedText>
            <Divider />
            <SubmittedText>
              {formatDateTime(submittedTimestamp, 'DD/MM/YYYY, HH:mm:ss')}
            </SubmittedText>
          </InfoPanel>
        )}
        <ButtonContainer>
          <ModelCheckbox
            label="Mark as complete"
            field="valuation.submitted"
            disabled={!canSubmit || checklistIndicatorType === 'Locked'}
            successColor={submitted}
            isCompleteCheckbox
          />
        </ButtonContainer>
      </SubmitContainer>
    </PaddedGenericSection>
  );
}
